// extracted by mini-css-extract-plugin
export default {"table":"DepartmentDetailsTable-module__table__SOO2d","link":"DepartmentDetailsTable-module__link__SzV69"};